export default {"src":"/_next/static/media/1.93842453.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};